var $export = require('./_export');
var define = require('./_object-define');

$export($export.S + $export.F, 'Object', { define: define });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/core.object.define.js
// module id = 292
// module chunks = 0